import { isDefinedString } from "et3-type-guards";
import i18n from "../../../../../constants/i18n";
import getFlaggedDesctiprionStore from "../../../../../stores/supervisor-store/flagged-description-store";
import Et3Button from "../../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import React from "react";
import Et3Picker from "../../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../../TypesNEW";

const UsersBannedFrom = withLiteObserverAndTheme(() => {
  const bannedUsersDescription =
    getFlaggedDesctiprionStore().bannedUsersDescription.get();
  const userBannedDescriptions =
    getFlaggedDesctiprionStore().userBannedDescriptions.get();
  const isEnabled = isDefinedString(
    getFlaggedDesctiprionStore().bannedUsersDescription.get().value
  );

  return (
    <React.Fragment>
      <Et3Button
        onClick={() => {
          getFlaggedDesctiprionStore().getBannedUsersDescription();
          getFlaggedDesctiprionStore().bannedUsersDescription.set({
            label: "",
            value: ""
          });
        }}
        isEnabled={true}
        size="SMALL"
        text="REFRESH"
        type="APPROVE"
      />
      <Et3Margin top={5} bottom={0} left={0} right={0} />
      <Et3Picker
        label={i18n.get("BANNED_USERS")}
        options={userBannedDescriptions}
        value={bannedUsersDescription}
        onChoose={(value: TEt3PickerSingleValue) => {
          getFlaggedDesctiprionStore().setBannedUsersDescription(value);
        }}
        isMultiple={false}
        style={{}}
        onEnter={() => {}}
        onClick={() => {}}
        containerStyle={{}}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        onClick={() => {
          getFlaggedDesctiprionStore().getBannedUsers();
        }}
        isEnabled={isEnabled}
        size="LARGE"
        text="GET"
        type="WARN"
      >
        {i18n.get("GET")}
      </Et3Button>
    </React.Fragment>
  );
});
export default UsersBannedFrom;
